/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './nag-alias-modal.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../../app/components/portal/a3i-setting/a3i-nag/nag-alias-modal/nag-alias-modal.component';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/material/core';
import * as i5 from '@angular/material/dialog';
const styles_NagAliasModalComponent:any[] = [i0.styles];
export const RenderType_NagAliasModalComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NagAliasModalComponent,data:{}});
export function View_NagAliasModalComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'app-modal-title']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(1,(null as any),['',''])),(_l()(),i1.ɵted(-1,
      (null as any),['\n'])),(_l()(),i1.ɵeld(3,0,(null as any),(null as any),11,'div',
      [['class','app-modal-content']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵeld(5,
      0,(null as any),(null as any),8,'div',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n		'])),(_l()(),i1.ɵeld(7,0,(null as any),(null as any),5,'input',[['name',
      'alias-name'],['placeholder','name'],['style','width:100%;']],[[2,'ng-untouched',
      (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
      [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
      [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
      'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
      'compositionend']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i2.NagAliasModalComponent = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,8)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,8).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,8)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,8)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_4:any = ((<any>(_co.aliasName = $event)) !== false);
      ad = (pd_4 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(8,16384,(null as any),0,i3.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i3.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i3.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i3.DefaultValueAccessor]),i1.ɵdid(10,671744,(null as any),0,i3.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i3.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i1.ɵprd(2048,
          (null as any),i3.NgControl,(null as any),[i3.NgModel]),i1.ɵdid(12,16384,
          (null as any),0,i3.NgControlStatus,[i3.NgControl],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵeld(16,0,
          (null as any),(null as any),12,'div',[['class','app-modal-footer']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n	'])),(_l()(),i1.ɵeld(18,0,(null as any),(null as any),
          9,'div',[['class','button-group']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n		'])),
      (_l()(),i1.ɵeld(20,0,(null as any),(null as any),2,'button',[['class','button-general'],
          ['md-raised-button','']],(null as any),[[(null as any),'click']],(_v,en,
          $event) => {
        var ad:boolean = true;
        var _co:i2.NagAliasModalComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.cancel()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(21,16384,(null as any),0,i4.MdPrefixRejector,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['Cancel'])),(_l()(),i1.ɵted(-1,(null as any),['\n		'])),(_l()(),i1.ɵeld(24,
          0,(null as any),(null as any),2,'button',[['class','button-general'],['md-raised-button',
              '']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.NagAliasModalComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.apply()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(25,16384,(null as any),0,i4.MdPrefixRejector,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),
          ['Apply'])),(_l()(),i1.ɵted(-1,(null as any),['\n	'])),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i2.NagAliasModalComponent = _v.component;
    const currVal_8:any = 'alias-name';
    const currVal_9:any = _co.aliasName;
    _ck(_v,10,0,currVal_8,currVal_9);
  },(_ck,_v) => {
    var _co:i2.NagAliasModalComponent = _v.component;
    const currVal_0:any = _co.title;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = i1.ɵnov(_v,12).ngClassUntouched;
    const currVal_2:any = i1.ɵnov(_v,12).ngClassTouched;
    const currVal_3:any = i1.ɵnov(_v,12).ngClassPristine;
    const currVal_4:any = i1.ɵnov(_v,12).ngClassDirty;
    const currVal_5:any = i1.ɵnov(_v,12).ngClassValid;
    const currVal_6:any = i1.ɵnov(_v,12).ngClassInvalid;
    const currVal_7:any = i1.ɵnov(_v,12).ngClassPending;
    _ck(_v,7,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
export function View_NagAliasModalComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-nag-alias-modal',
      ([] as any[]),(null as any),(null as any),(null as any),View_NagAliasModalComponent_0,
      RenderType_NagAliasModalComponent)),i1.ɵdid(1,114688,(null as any),0,i2.NagAliasModalComponent,
      [i5.MAT_DIALOG_DATA,i5.MatDialogRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NagAliasModalComponentNgFactory:i1.ComponentFactory<i2.NagAliasModalComponent> = i1.ɵccf('app-nag-alias-modal',
    i2.NagAliasModalComponent,View_NagAliasModalComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/portal/a3i-setting/a3i-nag/nag-alias-modal/nag-alias-modal.component.ngfactory.ts